/**
 * 判断文本的文字是否超出文本所在元素的宽度, 超出则给文本元素添加title属性
 */

export default {
	mounted(el: HTMLElement, binding: any): void {
		// 设置超出隐藏
		el.style.overflow = 'hidden';
		el.style.textOverflow = 'ellipsis';
		el.style.whiteSpace = 'nowrap';
		// 鼠标移入提示title
		if (el.clientWidth < el.scrollWidth && binding.value) {
			el.title = binding.value;
		}
	}
};
